import { Texture } from 'pixi.js';
import { onLayoutPopulated } from '../populate';
import { ButtonExtraLargeLayout } from '../../../../layouts/common/buttons/ButtonExtraLargeLayout';
import { ButtonLargeLayout } from '../../../../layouts/common/buttons/ButtonLargeLayout';
import { ButtonSmallLayout } from '../../../../layouts/common/buttons/ButtonSmallLayout';
import type { Layout } from '../populateLayouts/types/Layout';
import type { ButtonLayoutBase } from '../types/LayoutShapes';

type ButtonLayout = ButtonLayoutBase;

export function layoutApplyButtonProperties(): void {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  onLayoutPopulated.connect((layout: Layout) => {
    if (!isButtonLayout(layout)) return;

    const buttonLayout = layout as ButtonLayout;

    if (!buttonLayout.data) {
      console.warn('button layout does not have data property, fallback to grey button texture');
      return;
    }

    const colorToTextureMap: Record<string, string> = {
      blue: 'Button_Blue',
      green: 'Button_Green',
      grey: 'Button_Grey',
      yellow: 'Button_Yellow',
      orange: 'Button_Yellow',
      red: 'Button_Red',
    };

    const textureName = colorToTextureMap[buttonLayout.data.color];
    if (!textureName) {
      console.warn(`button layout uses unknown color ${buttonLayout.data.color}, fallback to grey button texture`);
      return;
    }

    buttonLayout.buttonNineSlice.texture = Texture.from(textureName);
  });
}

function isButtonLayout(layout: Layout): boolean {
  return [ButtonLargeLayout, ButtonSmallLayout, ButtonExtraLargeLayout].some(
    (layoutType) => layout instanceof layoutType,
  );
}
